import type { Router } from '@angular/router';

/** Navigates and logs a single diagnostic if the router rejects the transition. */
export function navigateOrReport(
  router: Router,
  commands: readonly unknown[],
  context: string
): void {
  router.navigate(commands).catch((error: unknown) => {
    console.error(`${context}:`, error);
  });
}
